























































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';

import moment from 'moment';
import { Actions, Mutations } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import TicketHelper from '@/mixins/TicketHelper.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import InlineImages from '@/components/Gallery/InlineImages.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';

import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';

@Component({
    components: {
        InlineImages,
    },
})
export default class StaffCreateTicketForm extends Mixins(
    InputFieldMethods,
    TicketHelper,
    DeviceMethods,
    NotifyMethods,
) {
    public form: any = {
        title: '',
        description: '',
        reporter: null,
        project: null,
        unit: null,
        type: null,
        category: null,
        assignee: null,
        priority: null,
    };
    public attachedFiles: any[] = [];
    public propertiesOptions: any = [];
    public assigneesOptions: any = [];
    public ticketSaving: boolean = false;

    public keyboardVisible: boolean = false;
    private fileData: File;

    constructor() {
        super();
        this.initializeKeyboardListener();
    }

    get userId(): number {
        return this.$store.getters['User/getUserId'];
    }

    get projects() {
        return this.$store.getters['Projects/allProjects'];
    }

    get properties() {
        return this.$store.getters['Tickets/getAddTicketProperties'];
    }

    get ticketTypes() {
        return this.$store.getters['TicketAttributes/getTicketAllTypes'];
    }

    get ticketCategories() {
        return this.$store.getters['TicketAttributes/getTicketAllCategories'];
    }

    get reporters() {
        return this.$store.getters['Tickets/getAddTicketRecievers'];
    }

    get assignees() {
        return this.$store.getters['Tickets/getTicketRoleAssignee'];
    }

    @Watch('form.project')
    public projectChanged() {
        this.form.unit     = null;
        this.form.category = null;
        this.form.assignee = null;

        this.$store.commit(Mutations.SET_ADD_TICKET_PROPERTIES, []);
        this.$store.commit(Mutations.SET_TICKET_ROLE_ASSIGNEE, []);

        if (this.form.project) {
            this.$store.dispatch(Actions.FETCH_ADD_TICKET_PROPERTIES, this.form.project);
        }
    }

    @Watch('form.unit')
    public unitChanged() {
        this.form.reporter = null;

        if (!this.form.unit) {
            return this.$store.commit(Mutations.SET_ADD_TICKET_RECIEVERS, []);
        }

        this.$store.dispatch(Actions.FETCH_ADD_TICKET_RECIEVERS, this.form.unit);
    }

    @Watch('form.type')
    public typeChanged() {
        this.form.category = null;

        if (this.form.project && this.form.type) {
            return this.$store.dispatch(Actions.FETCH_TICKET_ALL_CATEGORIES, {
                projectId: this.form.project,
                typeId: this.form.type,
                trash: false,
            });
        }
    }

    @Watch('form.category')
    public categoryChanged() {
        if (!this.form.category) {
            this.$store.commit(Mutations.SET_TICKET_ROLE_ASSIGNEE, []);
        }

        if (this.form.project && this.form.category) {
            return this.$store.dispatch(Actions.FETCH_TICKET_ROLE_ASSIGNEE, {
                projectId: this.form.project,
                categoryId: this.form.category,
                all: true,
            });
        }
    }

    @Watch('properties')
    public propertiesChanged() {
        this.propertiesOptions = this.properties;
    }

    @Watch('assignees')
    public assigneesChanged() {
        if (this.assigneesOptions.length) {
            this.sortAssignees();
        } else {
            this.assigneesOptions = this.assignees;
        }
    }
    public sortAssignees() {
        const authUser = this.assignees.find((assignee: any) => assignee.id === this.userId);

        if (authUser) {
            this.assigneesOptions = this.assignees.filter((assignee: any) => assignee.id !== this.userId);
            this.assigneesOptions.unshift(authUser);
        }
    }

    public initializeKeyboardListener(): void {
        if (this.$store.state.Viewport.deviceInfo.platform === 'web') {
            return;
        }

        Keyboard.setAccessoryBarVisible({ isVisible: true });

        Keyboard.addListener('keyboardDidShow', (info: KeyboardInfo) => {
            this.keyboardVisible = true;
        });

        Keyboard.addListener('keyboardDidHide', () => {
            this.keyboardVisible = false;
        });
    }

    public checkStatus(type: string) {
        switch (type) {
            case 'type':
                if (!this.form.project) {
                    return this.notify('select_project_first', 'primary-notify', '', 3000, 'top');
                }
                break;
            case 'reporter':
                if (!this.form.project || !this.form.unit) {
                    return this.notify('select_project_unit_first', 'primary-notify', '', 3000, 'top');
                }
                break;
            case 'assignee':
                if (!this.form.project || !this.form.category) {
                    return this.notify('select_project_category_first', 'primary-notify', '', 3000, 'top');
                }
                break;
            case 'category':
                if (!this.form.project || !this.form.type) {
                    return this.notify('select_project_type_first', 'primary-notify', '', 3000, 'top');
                }
                break;
        }
    }

    public filter(val: any, update: any, abort: any) {
        update(() => {
            const needle = val.toLowerCase();
            this.propertiesOptions = this.properties.filter((v: any) => v.address.street.toLowerCase().indexOf(needle) > -1);
        });
    }

    public filterAssignees(val: any, update: any, abort: any) {
        update(() => {
            const needle = val.toLowerCase();

            this.assigneesOptions = this.assignees.filter((assignee: any) =>  {
                const fullName = assignee.person.first_name + ' ' + assignee.person.family_name;

                return fullName.toLowerCase().indexOf(needle) > -1;
            });

            const authUser = this.assigneesOptions.find((assignee: any) => assignee.id === this.userId);

            if (authUser) {
                this.assigneesOptions = this.assigneesOptions.filter((assignee: any) => assignee.id !== this.userId);
                this.assigneesOptions.unshift(authUser);
            }
        });
    }

    public create() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.ticketSaving = true;

                const formData: any = new FormData();

                formData.append('ticketTitle', this.form.title);
                formData.append('ticketMessage', this.form.description);
                formData.append('ticketProject', this.form.project);
                if (this.form.unit) { formData.append('ticketProperty', this.form.unit); }
                if (this.form.reporter) { formData.append('ticketReceiver', this.form.reporter); }
                formData.append('ticketType', this.form.type);
                formData.append('ticketCategory', this.form.category);
                formData.append('ticketAssignee', this.form.assignee);
                formData.append('ticketPriority', this.form.priority);

                this.attachedFiles.forEach((file: any) => {
                    formData.append('photos[]', file);
                });

                this.$store.dispatch(Actions.ADMIN_ADD_TICKET, {requestData: formData, vue: this, mobile: true}).then(() => {
                    this.closeGlobalOverlay();
                    this.ticketSaving = false;
                });
            }
        });
    }

    public closeGlobalOverlay() {
        this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_CONFIG, {})
            .then(() => {
                this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_VISIBILITY, false);
            });
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_TICKET_ALL_TYPES);
    }

    /**  ----  Images related functionality ----- */

    public showFileInputDialog() {
        (this.$refs.fileInputElement as HTMLInputElement).click();
    }

    public showCameraDialog() {
        this.device().then((deviceInfo: any) => {
            deviceInfo.platform === 'web' ? this.showFileInputDialog() : this.requestMobileImage();
        });
    }

    public removeAttachItem(index: number) {
        this.attachedFiles = this.attachedFiles.filter((file: any, i: number) => i !== index);
        this.resetAttachmentInput();
    }

    public resetAttachmentInput() {
        this.fileData = null;

        const input = this.$refs.fileInputElement as HTMLInputElement;
        input.type = 'text';
        input.type = 'file';
    }

    public handleFileChange(event: Event) {
        this.fileData = (event.target as HTMLInputElement).files[0];

        if (typeof this.fileData === 'undefined' || this.fileData === null) {
            this.resetAttachmentInput();
            return;
        }

        const reader = new FileReader();
        const tempImage = new Image();
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        reader.readAsDataURL(this.fileData);
        reader.onload = (e: any) => {
            const image  = new Image();
            image.src = e.target.result;

            image.onload = () => {
                const height = image.height;
                const width  = image.width;
                tempImage.src = e.target.result;
            };

            tempImage.onload = () => this.uploadImage(tempImage, canvas, context);
        };
    }

    public uploadImage(tempImage: any, canvas: any, context: any) {
        const width = 1024;
        const widthProportion = width / tempImage.width;
        const height = tempImage.height * widthProportion;

        canvas.width = width;
        canvas.height = height;
        context.drawImage(tempImage, 0, 0, width, height);
        tempImage = null;

        canvas.toBlob((blob: any) => {
            const file = new File([blob], moment().format('x') + '.jpeg', { type: 'image/jpeg' });
            this.attachedFiles.push(file);
        });
    }

    private async requestMobileImage(): Promise<boolean> {
        const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.DataUrl,
            source: CameraSource.Prompt,
        })
            .then((photo) => {
                let tempImage = new Image();
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');

                tempImage.onload = () => {
                    const width = 1024;
                    const widthProportion = width / tempImage.width;
                    const height = tempImage.height * widthProportion;

                    canvas.width = width;
                    canvas.height = height;
                    context.drawImage(tempImage, 0, 0, width, height);
                    tempImage = null;
                    canvas.toBlob((blob) => {
                        const file = new File([blob], moment().format('x') + '.jpeg', { type: 'image/jpeg' });
                        this.attachedFiles.push(file);
                    });

                };

                tempImage.src = photo.dataUrl;
            });

        return true;
    }
}
